
export const ATHLETE_TIER_DEFAULT_VALUES = {
  sport: "",
  sportLevel: "",
  positionRole: "",
  seasonCycle: "off_season" as const,
  sportSpecificGoals: "",
  importantDates: "",
  sportTrainingLoad: "",
  sportInjuries: "",
  keyPerformanceAreas: [] as string[],
  recoveryTravel: "",
};

export const ATHLETE_TIER_TITLE = "Athlete Program Questions";
export const ATHLETE_TIER_DESCRIPTION = "These questions help customize the program for competitive athletes";
